import { useState, useEffect, useCallback, useRef } from 'react';

export const useProjectDetailsForm = (initialState) => {
  const [projectDetails, setProjectDetails] = useState(initialState);
  const debounceTimers = useRef({});

  useEffect(() => {
    // This is useful for debugging purposes to see the current state
  }, [projectDetails]);

  // Immediate input change (for dropdowns and other controls)
  const handleInputChange = useCallback((e) => {
    const { name, value } = e.target;
    setProjectDetails(prevDetails => ({ ...prevDetails, [name]: value }));
  }, []);

  // Debounced input change (for text inputs to improve performance)
  const handleDebouncedInputChange = useCallback((e, delay = 300) => {
    const { name, value } = e.target;

    // Clear existing timer for this field
    if (debounceTimers.current[name]) {
      clearTimeout(debounceTimers.current[name]);
    }

    // Set new timer
    debounceTimers.current[name] = setTimeout(() => {
      setProjectDetails(prevDetails => ({ ...prevDetails, [name]: value }));
    }, delay);
  }, []);

  const resetForm = useCallback(() => {
    // Clear all debounce timers
    Object.values(debounceTimers.current).forEach(timer => clearTimeout(timer));
    debounceTimers.current = {};

    setProjectDetails(initialState);
  }, [initialState]);

  // Cleanup timers on unmount
  useEffect(() => {
    return () => {
      Object.values(debounceTimers.current).forEach(timer => clearTimeout(timer));
    };
  }, []);

  return [projectDetails, handleInputChange, resetForm, handleDebouncedInputChange];
};